import React, { useEffect, useState } from 'react';
import { FormControl, FormHelperText, Icon, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import DialogBase from './DialogBase';
import { BaseForm } from '../../../forms/baseForm';
import { emailRule, requiredRule } from '../../../forms/validationRules';
import { getRoleLabel, OrganisatieUserRole } from '../../../models/user/userRole';

interface DialogInviteUserProps {
  open: boolean;
  organisatieId: string;
  allowedRoles: OrganisatieUserRole[];
  onClose: () => void;
  onSubmit: (organisatieId: string, formValues: Record<string, string>) => void;
}

const form = new BaseForm({ email: '', role: 'user' });

const DialogInviteUser: React.FC<DialogInviteUserProps> = ({
  open,
  organisatieId,
  allowedRoles,
  onClose,
  onSubmit,
}) => {
  const [formState, setFormState] = useState(form.getFormState());

  useEffect(() => {
    if (open) {
      form.reset();
      form.setFieldValue('role', allowedRoles[0] ?? 'user');
      setFormState(form.getFormState()); // Sync UI state
    }
  }, [open, allowedRoles]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    form.setFieldValue(name, value);
    setFormState(form.getFormState());
  };

  const handleRoleChange = (event: SelectChangeEvent<string>) => {
    form.setFieldValue('role', event.target.value);
    setFormState(form.getFormState());
  };

  const handleSubmit = () => {
    const isValid = form.validateAll({
      email: { displayName: 'E-mailadres', rules: [requiredRule, emailRule] },
      role: { displayName: 'Rol', rules: [requiredRule] },
    });

    setFormState(form.getFormState()); // Update state with errors

    const currentFormState = form.getFormState();
    
    if (isValid) {
      onSubmit(organisatieId, currentFormState.values);
      onClose();
    }
  };

  return (
    <DialogBase
      open={open}
      title={'Gebruiker uitnodigen'}
      contentText={'Nodig een gebruiker uit en kies direct de rol binnen deze organisatie. Wanneer de gebruiker al een account heeft bij infraplannen.nl dan wordt deze direct toegevoegd aan deze organisatie.'}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmButtonText="Verzend"
      confirmButtonIcon={<Icon>send</Icon>}
    >
      <section>
        <label>Kies eerst de rol van de gebruiker</label>
        <br />

        <FormControl fullWidth variant="filled" error={!!formState.errors.role}>
          <InputLabel id="select-user-role-label">Rol</InputLabel>
          <Select
            labelId="select-user-role-label"
            id="select-user-role"
            value={formState.values.role}
            onChange={handleRoleChange}
            label="Rol"
          >
            {allowedRoles.map((role: OrganisatieUserRole) => (
              <MenuItem key={role} value={role}>
                {getRoleLabel(role)}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{formState.errors.role || ' '}</FormHelperText>
        </FormControl>

        <br />

        <label>Vul daarna het e-mailadres in</label>
        <br/>

        <TextField
          fullWidth
          required
          name="email"
          label="E-mailadres"
          value={formState.values.email}
          onChange={handleInputChange}
          error={!!formState.errors.email}
          helperText={formState.errors.email || ' '}
          variant="filled"
          />
        
      </section>
      
    </DialogBase>
  );
};

export default DialogInviteUser;
